import React, { useState, useEffect, Fragment } from "react";
import { AxiosAPI } from '../../../../../../helpers/AxiosAPI';
import { putAPI_Update_Image, putAPI_Delete_Image } from '../../../../../../constants/APIs';
import TagsInput from "react-tagsinput";
import "react-tagsinput/react-tagsinput.css";
import {
    Row,
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Input
} from 'reactstrap';
import Validation from "../../../../../../components/Validation";
import { Colxx } from '../../../../../../components/common/CustomBootstrap';
import IntlMessages from "../../../../../../helpers/IntlMessages";
const Checkmark = ({ selected }) => (
    <div
        style={
            selected
                ? { top: "4px", position: "absolute", zIndex: "1" }
                : { display: "none" }
        }
    >
        <svg
            style={{ fill: "white", position: "absolute" }}
            width="24px"
            height="24px"
        >
            <circle cx="12.5" cy="12.2" r="8.292" />
        </svg>
        <svg
            style={{ fill: "#06befa", position: "absolute" }}
            width="24px"
            height="24px"
        >
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
        </svg>
    </div>
);

const imgStyle = {
    width: "30px", height: "30px",
    transition: "transform .135s cubic-bezier(0.0,0.0,0.2,1),opacity linear .15s"
};
const selectedImgStyle = {
    transform: "translateZ(0px) scale3d(0.9, 0.9, 1)",
    transition: "transform .135s cubic-bezier(0.0,0.0,0.2,1),opacity linear .15s"
};
const imgDiv = {
    position: "relative",
    display: "inline-block",
    width: "100px",
    height: "100px",
    backgroundColor: "#fff",
    padding: "10px", cursor: "pointer"
}

const UserUploadSelectedIcon = ({
    index,
    photo,
    selected,
    ParentUserUploadImage,
    chosenImage,
    ParentUserDeleteImage,
    ParentUserEditImage
}) => {
    const [open, setOpen] = useState(false);
    const [msg, setMsg] = useState([]);
    const [isSelected, setIsSelected] = useState(selected);
    const [selectedImg, setselectedImg] = useState(chosenImage);
    const [deleteVisible, setDeleteVisible] = useState(false);
    const [imageTags, setimageTags] = useState(photo.tags);
    const [imageCaption, setImageCaption] = useState(photo.caption);
    const [editVisible, seteditVisible] = useState(false);
    const sx = (100 - (30 / 250) * 100) / 100;
    const sy = (100 - (30 / 250) * 100) / 100;
    selectedImgStyle.transform = `translateZ(0px) scale3d(${sx}, ${sy}, 1)`;

    const handleOnClick = (id, event) => {
        setselectedImg(id)
        ParentUserUploadImage(id);
    };
    const handleTagChange = (event) => {
        setimageTags(event);
    };
    const toggle = () => {
        setDeleteVisible(!deleteVisible);
    };
    const toggleedit = () => {
        seteditVisible(!editVisible);
    };
    const handleChange = (event) => {
        setImageCaption(event.target.value);
    };

    const handleDelete = () => {
        AxiosAPI({
            method: 'put',
            url: `${putAPI_Delete_Image}/${photo.id}`,
            data: {
                deleter: 'dashboard'
            },
        })
            .then(res => {
                toggle();
                ParentUserDeleteImage(photo.id)
            })
            .catch(err => {
                console.log(err);
            });
    };

    const handleUpdate = () => {
        AxiosAPI({
            method: 'put',
            url: `${putAPI_Update_Image}/${photo.id}`,
            data: {
                deleter: 'dashboard',
                tags: imageTags,
                caption: imageCaption
            },
        })
            .then(res => {
                if (res.data.HttpStatusCode !== undefined && res.data.HttpStatusCode === 400 && res.data.Messages !== undefined
                    && res.data.Messages !== null && res.data.Messages.length > 0) {
                    setMsg(res.data.Messages);
                    setOpen(true);
                }
                else {
                    toggleedit();
                    ParentUserEditImage(photo.id, imageTags);
                }
            })
            .catch(err => {
                console.log(err);
            });
    };

    const generateDeleteButton = () => {
        return deleteVisible && (
            <Row>
                <Colxx xs="12" sm="12" md="12" lg="8" className="mb-4">
                    <Row>
                        <Colxx xs="12" sm="3" className="mb-1">
                            <Modal isOpen={deleteVisible} toggle={toggle}>
                                <ModalHeader toggle={toggle}>
                                    <span role="img" aria-label="warning">
                                        ⚠️
                                    </span>
                                    This image will be deleted!
                                </ModalHeader>
                                <ModalBody>
                                    <Button
                                        color="danger"
                                        onClick={() => handleDelete()}
                                        size="xs"
                                    >
                                        <IntlMessages id='dashboards.delete' />
                                    </Button>
                                    <Button
                                        className="ml-2"
                                        color="dark"
                                        outline
                                        size="xs"
                                        onClick={toggle}
                                    >
                                        <IntlMessages id='pages.cancel' />
                                    </Button>
                                </ModalBody>
                            </Modal>
                        </Colxx>
                    </Row>
                </Colxx>
            </Row>
        );
    };

    const generateEditButton = () => {
        return editVisible && (
            <Row>
                <Colxx xs="12" sm="12" md="12" lg="8" className="mb-4">
                    <Row>
                        <Colxx xs="12" sm="3" className="mb-1">
                            <Modal isOpen={editVisible} toggle={toggleedit}>
                                <ModalHeader toggle={toggleedit}>
                                    Edit Search Tags & Caption
                                </ModalHeader>
                                <ModalBody>
                                    <Row className="mb-4">
                                        <Colxx xxs="12">
                                            <TagsInput
                                                value={imageTags}
                                                onChange={event => handleTagChange(event)}
                                            />
                                        </Colxx>
                                    </Row>
                                    <Row className="mb-4">
                                        <Colxx xxs="12">
                                            <Input
                                                type="text"
                                                name="caption"
                                                placeHolder="Caption"
                                                value={imageCaption}
                                                onChange={event => handleChange(event)}
                                            />
                                        </Colxx>
                                    </Row>
                                </ModalBody>
                                <ModalFooter>
                                    <Button
                                        color="secondary"
                                        onClick={() => handleUpdate()}
                                        size="xs"
                                    >
                                        <IntlMessages id='dashboards.update' />
                                    </Button>
                                    <Button
                                        className="ml-2"
                                        color="dark"
                                        outline
                                        size="xs"
                                        onClick={toggleedit}
                                    >
                                        <IntlMessages id='pages.cancel' />
                                    </Button>
                                </ModalFooter>
                            </Modal>
                        </Colxx>
                    </Row>
                </Colxx>
            </Row>
        );
    };

    useEffect(() => {
        setIsSelected(selected);
    }, [selected]);

    return (
        <Fragment>
            <div className="text-center">
                <div style={{ ...imgDiv }} className={chosenImage !== photo.id ? "not-selected" : ""}>
                    <Checkmark selected={chosenImage == photo.id ? true : false} />
                    <img src={photo.src}
                        style={
                            chosenImage == photo.id ? { ...imgStyle, ...selectedImgStyle } : { ...imgStyle }
                        }
                        onClick={event => handleOnClick(photo.id, event)}
                    ></img>
                    <style>{`.not-selected:hover{outline:2px solid #06befa}`}</style>
                    <p className="mt-3">{photo.caption}</p>
                    <div>
                        <a href="#/" onClick={toggleedit}>{" "}<i className="glyph-icon simple-icon-pencil" />{" "}</a>
                        <a href="#/" onClick={toggle}>{" "} <i className="glyph-icon simple-icon-trash" />{" "}</a>
                    </div>
                </div>
            </div>
            {generateDeleteButton()}
            {generateEditButton()}
            <Validation open={open} messages={msg} toggle={() => { setOpen(!open) }}></Validation>
        </Fragment>
    );
};

export default UserUploadSelectedIcon;